import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDZ6MRR2rWRUUqSKPai5J1HxMMEaFbaP80",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "client-relationship-mana-6042a.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "client-relationship-mana-6042a",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "client-relationship-mana-6042a.firebasestorage.app",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "847389813282",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:847389813282:web:24d81e7b60cf5ed70cb87b",
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-ER3FQFDNHN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export const functions = getFunctions(app);

// Connect to Emulators if configured via .env
const useEmulators = process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true';

if (useEmulators) {
    console.log('[Firebase] Connecting to local Firebase Emulators...');
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    connectFirestoreEmulator(db, 'localhost', 8080);
    connectFunctionsEmulator(functions, 'localhost', 5001);
}

// Cloud Functions helpers
export const setUserPasswordAuth = httpsCallable(functions, 'setUserPassword');
export const enableUserAuth = httpsCallable(functions, 'enableUser');
export const disableUserAuth = httpsCallable(functions, 'disableUser');

export default app;
